import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=224b8598&scoped=true&"
import script from "./ProductDetail.vue?vue&type=script&lang=js&"
export * from "./ProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ProductDetail.vue?vue&type=style&index=1&id=224b8598&lang=less&scoped=true&"
import style2 from "./ProductDetail.vue?vue&type=style&index=2&id=224b8598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224b8598",
  null
  
)

export default component.exports